const emailPattern = /^(?:[A-Za-z0-9._%+\-]+)@[A-Za-z0-9.-]+\.[A-Za-z]{2,63}$/i
const namePattern = /^[A-Za-z0-9_\-]{5,20}$/i
const emailOrNamePattern = /^(?:[A-Za-z0-9._%+\-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,63}|[A-Za-z0-9_\-]{5,20})$/i
// At least 1 lowercase, 1 uppercase, 1 digit and 1 special (non‑word) character; allow any non‑whitespace Unicode char, min 8 chars
const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])\S{8,}$/u
const facebookPattern = /^(http|https):\/\/(www\.)?facebook\.com\/[a-zA-Z0-9.]+[a-zA-Z0-9_\/]*[^.]+$/
const youtubePattern = /^(http|https):\/\/(www\.)?youtube\.com\/(channel\/|user\/)?[a-zA-Z0-9_-]+[a-zA-Z0-9_\/]*[^.]+$/
const instagramPattern = /^(http|https):\/\/(www\.)?instagram\.com\/[a-zA-Z0-9_.]+[a-zA-Z0-9_\/]*[^.]+$/
const twitterPattern = /^(http|https):\/\/(www\.)?(twitter\.com|x\.com)\/[a-zA-Z0-9_]+[a-zA-Z0-9_\/]*[^.]+$/

export const signupFormConfig = {
  name: {
    emptyMessage: 'signup_view_error_username_empty',
    rules: [
      {
        pattern: namePattern,
        errorMessage: 'signup_view_error_username_mask'
      },
      {
        minLength: 5,
        maxLength: 20,
        errorMessage: 'signup_view_error_username_length'
      }
    ]
  },
  email: {
    emptyMessage: 'signup_view_error_email_empty',
    rules: [
      {
        pattern: emailPattern,
        errorMessage: 'signup_view_error_email_format'
      }
    ]
  },
  password: {
    emptyMessage: 'signup_view_error_password_empty',
    rules: [
      {
        minLength: 8,
        maxLength: 64,
        errorMessage: 'signup_view_error_password_length'
      },
      {
        pattern: passwordPattern,
        errorMessage: 'signup_view_error_password_mask'
      }
    ]
  },
  password_repeat: {
    emptyMessage: 'signup_view_error_password_empty',
    rules: [
      {
        matchField: 'password',
        errorMessage: 'signup_view_error_password_match'
      }
    ]
  }
}

export const resetPasswordFormConfig = {
  password: {
    emptyMessage: 'signup_view_error_password_empty',
    rules: [
      {
        minLength: 8,
        maxLength: 64,
        errorMessage: 'signup_view_error_password_length'
      },
      {
        pattern: passwordPattern,
        errorMessage: 'signup_view_error_password_mask'
      }
    ]
  },
  password_repeat: {
    emptyMessage: 'signup_view_error_password_empty',
    rules: [
      {
        matchField: 'password',
        errorMessage: 'signup_view_error_password_match'
      }
    ]
  }
}

export const forgotPasswordFormConfig = {
  email: {
    emptyMessage: 'forgot_password_view_error_email_empty',
    rules: [
      {
        pattern: emailPattern,
        errorMessage: 'forgot_password_view_error_email_format'
      }
    ]
  }
}

export const signinFormConfig = {
  email: {
    emptyMessage: 'login_view_error_email_empty',
    rules: [
       {
          pattern: emailOrNamePattern,
          errorMessage: 'login_view_error_email_invalid'
       }
     ]
   },
  password: {
    emptyMessage: 'login_view_error_password_empty'
  }
}

export const changePasswordFormConfig = {
  old_password: {
    emptyMessage: 'profile_menu_change_password_old_pass_empty'
  },
  new_password: {
    rules: [
      {
        minLength: 8,
        maxLength: 64,
        errorMessage: 'signup_view_error_password_length'
      },
      {
        pattern: passwordPattern,
        errorMessage: 'signup_view_error_password_mask'
      }
    ],
    emptyMessage: 'signup_view_error_password_empty'
  },
  new_password_repeat: {
    rules: [
      {
        matchField: 'new_password',
        errorMessage: 'signup_view_error_password_match'
      }
    ],
    emptyMessage: 'signup_view_error_password_empty'
  }
}

export const profileFormConfig = {
  name: {
    rules: [
      {
        pattern: namePattern,
        errorMessage: 'signup_view_error_username_mask'
      },
      {
        minLength: 5,
        maxLength: 20,
        errorMessage: 'signup_view_error_username_length'
      }
    ],
    emptyMessage: 'signup_view_error_username_empty'
  },
  email: {
    rules: [
      {
        pattern: emailPattern,
        errorMessage: 'signup_view_error_email_format'
      }
    ],
    emptyMessage: 'signup_view_error_email_empty'
  }
}

export const socialsFormConfig = {
  link_facebook: {
    rules: [
      {
        pattern: facebookPattern,
        errorMessage: 'profile_menu_edit_profile_error_invalid_domain_name'
      }
    ]
  },
  link_youtube: {
    rules: [
      {
        pattern: youtubePattern,
        errorMessage: 'profile_menu_edit_profile_error_invalid_domain_name'
      }
    ]
  },
  link_instagram: {
    rules: [
      {
        pattern: instagramPattern,
        errorMessage: 'profile_menu_edit_profile_error_invalid_domain_name'
      }
    ]
  },
  link_twitter: {
    rules: [
      {
        pattern: twitterPattern,
        errorMessage: 'profile_menu_edit_profile_error_invalid_domain_name'
      }
    ]
  },
  link_email: {
    rules: [
      {
        pattern: emailPattern,
        errorMessage: 'signup_view_error_email_format'
      }
    ]
  }
} 